import appConfig from '@app';
import { store } from '@shared/store/store';
import { IAppUrls, Url, ImagesUrls } from '@shared/types/interfaces/config';

class Config {
  // Misc
  environment: string;
  // Urls
  appUrls: IAppUrls;
  images: ImagesUrls;

  constructor() {
    // Misc
    this.environment = appConfig.environment;

    // Urls
    this.appUrls = {
      apiUrl: 'https://api.tvup.cloud',
      baseImgUrl: 'https://media.tvup.cloud',
      cdnSyncUrl: 'https://mediasync.tvup.cloud',
      channelLicense: 'https://drmnew.tvup.cloud/license/',
      freeChannelLicense: 'https://drmnew.tvup.cloud/freelicense/',
      freeVodLicense: 'https://drmnew.tvup.cloud/freelicense/vod/',
      graphQLUrl: 'https://api.tvup.cloud/graphql',
      serverless: 'https://lpw3718wr0.execute-api.eu-west-1.amazonaws.com', // Prod: https://lpw3718wr0.execute-api.eu-west-1.amazonaws.com | Dev: https://6etq2m70e3.execute-api.eu-west-1.amazonaws.com
      vodLicense: 'https://drmnew.tvup.cloud/license/vod/',
    };
    this.images = {
      channelsClassic:
        'https://media.tvup.cloud/carriers/{OPERATOR_ID}/channels_epg_option.png',
      channelsDial:
        'https://media.tvup.cloud/carriers/{OPERATOR_ID}/dial_option.png',
    };
  }

  getUrl(url: Url) {
    const { app } = store.getState();

    return (
      app.urls[url || 'cdnSyncUrl'] || this.appUrls[url || 'cdnSyncUrl'] || ''
    );
  }
}

const AppConfig = new Config();
export default AppConfig;
